import axiosInstance from "../../../utils/axios";
import { objToURL } from "../../../utils/commonfunction";
import { ROLE } from "../../../utils/Constants";

const options = { role: ROLE.SUPER_ADMIN };
const path = "admin/contact-us";

export const List = async (values) => {
    return await axiosInstance(options).get(`${path}/list${objToURL(values)}`);
};

export const Details = async (id) => {
    return await axiosInstance(options).post(`${path}/details`, { id });
};

export const StatusChange = async (id, data) => {
    return await axiosInstance(options).put(`${path}/status-change/${id}`, data);
};

export const Delete = async (id) => {
    return await axiosInstance(options).delete(`${path}/delete/${id}`);
};
